<template>
  <td style="padding: 0 !important;">
    <div :class="setColor()" class="inCellHeight" v-if="macd">
      {{ macd.histogram }}
      (<i :class="setIcon()"/>)
    </div>
    <div class="inCellHeight" v-else>-</div>
  </td>

</template>

<script>
export default {
  name: "MACDCell",
  props: ['macd'],
  methods: {
    setIcon() {

      return this.macd.direction === 'bullish' ? 'ri-arrow-right-up-line' : this.macd.direction === 'bearish' ? 'ri-arrow-right-down-line' : 'ri-pulse-line';
    },
    setColor() {

      const hist = this.macd.histogram;
      const dir = this.macd.direction;

      if (dir === "bullish" && hist > 0) {
        return "green";
      }

      if (dir === "bearish" && hist < 0) {
        return "red";
      }
    }
  }
}
</script>

<style scoped lang="scss">
td {
  padding: 0 !important;
}

div {
  padding: 7.5px 10px !important;
}
</style>
